<div class="py-5">
  <div class="container">
    <div class="row align-items-center mt-1">
      <!-- Text Section -->
      <div class="col-lg-8 col-md-12 mb-4 mb-lg-0">
            <h1 class="mb-3 text-gray-900 bg-white dark:text-white dark:bg-gray-900">
      Innovative IT and Software Solutions
    </h1>
        <p class="mb-4 para">
          MALtech is a trusted technology partner offering end-to-end software
          development, software consulting, and DevOps solutions. It leverages
          AI and digital growth strategies to drive innovation and business
          transformation.
        </p>
        <div  class="d-flex justify-content-start justify-content-sm-start justify-content-center justify-content-md-start gap-3">

          
          <a
  class="custom-btn me-3 mb-2 text-decoration-none"
  aria-label="Work With Us"
  routerLink="/contact"
  href="/contact"
>
  Work With Us
</a>

        </div>
      </div>

      <!-- Image Section -->
      <div class="col-lg-4 col-md-12 text-center image-container">
<img
  src="/assets/images/home/home-banner/homePage4-370.webp"
  srcset="
    /assets/images/home/home-banner/homePage4-370.webp 370w,
    /assets/images/home/home-banner/homePage4-740.webp 740w
  "
  sizes="370px"
  alt="Homepage Banner"
  fetchpriority="high"
  class="custom-width mx-auto d-block"
  width="370"
  height="244"
/>
      </div>
    </div>
  </div>
</div>

<div class="container p-2">
  <div class="row solutions-section">
    <div class="col-12">

      <h2 class="text-center subHeading">Our Solutions</h2>

      <!-- Responsive Tabs -->
      <div class="container my-4">
        <ul
          class="nav row g-2 justify-content-center"
          id="myTab"
          role="tablist"
          aria-label="Our Solutions"
        >

          <!-- Software Development -->
          <li
            class="nav-item col-6 col-sm-6 col-md-3 text-center"
            role="presentation"
          >
            <button
              id="development-tab"
              class="nav-link p-2 p-sm-3 p-md-4 custom-tab-button w-100"
              [class.active]="activeTab === 'development'"
              type="button"
              role="tab"
              aria-controls="development-panel"
              [attr.aria-selected]="activeTab === 'development' ? 'true' : 'false'"
              (click)="setActiveTab('development')"
            >
              Software Development
            </button>
          </li>

          <!-- Software Consulting -->
          <li
            class="nav-item col-6 col-sm-6 col-md-3 text-center"
            role="presentation"
          >
            <button
              id="consulting-tab"
              class="nav-link p-2 p-sm-3 p-md-4 custom-tab-button w-100"
              [class.active]="activeTab === 'consulting'"
              type="button"
              role="tab"
              aria-controls="consulting-panel"
              [attr.aria-selected]="activeTab === 'consulting' ? 'true' : 'false'"
              (click)="setActiveTab('consulting')"
            >
              Software Consulting
            </button>
          </li>

          <!-- DevOps Solutions -->
          <li
            class="nav-item col-6 col-sm-6 col-md-3 text-center"
            role="presentation"
          >
            <button
              id="solutions-tab"
              class="nav-link p-2 p-sm-3 p-md-4 custom-tab-button w-100"
              [class.active]="activeTab === 'solutions'"
              type="button"
              role="tab"
              aria-controls="solutions-panel"
              [attr.aria-selected]="activeTab === 'solutions' ? 'true' : 'false'"
              (click)="setActiveTab('solutions')"
            >
              DevOps Solutions
            </button>
          </li>

          <!-- Digital Marketing -->
          <li
            class="nav-item col-6 col-sm-6 col-md-3 text-center"
            role="presentation"
          >
            <button
              id="marketing-tab"
              class="nav-link p-2 p-sm-3 p-md-4 custom-tab-button w-100"
              [class.active]="activeTab === 'marketing'"
              type="button"
              role="tab"
              aria-controls="marketing-panel"
              [attr.aria-selected]="activeTab === 'marketing' ? 'true' : 'false'"
              (click)="setActiveTab('marketing')"
            >
              Digital Marketing
            </button>
          </li>

        </ul>
      </div>

      <!-- Tab Content -->
      <div class="tab-content" id="myTabContent">

        <!-- ==========================================================
             SOFTWARE DEVELOPMENT
        =========================================================== -->
        <div
          *ngIf="activeTab === 'development'"
          id="development-panel"
          class="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="development-tab"
          tabindex="0"
        >

          <!-- Card 1 -->
          <div class="card m-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/sdwad.webp"
                  class="img-fluid"
                  alt="Web Application Development"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h3 class="heading-section-card">
                  Web Application Development
                </h3>

                <p class="para">
                  We build modern, scalable, and responsive web applications
                  that deliver seamless performance across devices.
                  <br />
                  From enterprise dashboards to customer portals, our
                  solutions are tailored for reliability and growth.
                </p>

                <a
                  routerLink="/service/software-development/"
                  href="/service/software-development/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore web application development"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

          <!-- Card 2 -->
          <div class="card m-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/sdmad.webp"
                  class="img-fluid"
                  alt="Mobile App Development"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h4 class="heading-section-card">
                  Mobile App Development
                </h4>

                <p class="para">
                  We build modern, scalable, and responsive mobile
                  applications that deliver seamless performance across
                  devices. From enterprise dashboards to customer portals,
                  our solutions are tailored for reliability and growth.
                </p>

                <a
                  routerLink="/service/software-development/"
                  href="/service/software-development/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore mobile app development"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

          <!-- Card 3 -->
          <div class="card m-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/sdess.webp"
                  class="img-fluid"
                  alt="Enterprise Software Solutions"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h4 class="heading-section-card">
                  Enterprise Software Solutions
                </h4>

                <p class="para">
                  We create custom ERP, CRM, and workflow automation systems
                  that simplify complex operations, improve collaboration,
                  and drive digital transformation across organizations.
                </p>

                <a
                  routerLink="/service/software-development/"
                  href="/service/software-development/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore enterprise software solutions"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

        </div>


        <!-- ==========================================================
             SOFTWARE CONSULTING
        =========================================================== -->
        <div
          *ngIf="activeTab === 'consulting'"
          id="consulting-panel"
          class="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="consulting-tab"
          tabindex="0"
        >

          <!-- Card 1 -->
          <div class="card m-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/sctsr.webp"
                  class="img-fluid"
                  alt="Technology Strategy and Roadmapping"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h4 class="heading-section-card">
                  Tech Strategy &amp; Roadmap
                </h4>

                <p class="para">
                  We provide expert guidance to help businesses make the right
                  technology choices. From evaluating software stacks, cloud
                  adoption strategies, and automation tools to defining
                  long-term IT roadmaps, we ensure your investments are
                  scalable, secure, and future-ready.
                </p>

                <a
                  routerLink="/service/software-consulting-services/"
                  href="/service/software-consulting-services/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore technology strategy and roadmap"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

          <!-- Card 2 -->
          <div class="card m-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/scasd.webp"
                  class="img-fluid"
                  alt="Architecture and System Design"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h4 class="heading-section-card">
                  Architecture &amp; System Design
                </h4>

                <p class="para">
                  Our team specializes in designing enterprise-grade software
                  architectures tailored to your specific needs. We focus on
                  scalability, flexibility, and security while ensuring
                  seamless integration with your existing systems.
                </p>

                <a
                  routerLink="/service/software-consulting-services/"
                  href="/service/software-consulting-services/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore architecture and system design"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

          <!-- Card 3 -->
          <div class="card mt-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/scpodt.webp"
                  class="img-fluid"
                  alt="Process Optimization and Digital Transformation"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h4 class="heading-section-card">
                  Digital Process Optimization
                </h4>

                <p class="para">
                  We empower businesses to modernize legacy systems and
                  transition to agile, automated, and efficient workflows.
                  Our consulting services include adopting DevOps practices,
                  automating manual processes, and implementing modern
                  software tools that enhance productivity.
                </p>

                <a
                  routerLink="/service/software-consulting-services/"
                  href="/service/software-consulting-services/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore digital process optimization"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

        </div>


        <!-- ==========================================================
             DEVOPS SOLUTIONS
        =========================================================== -->
        <div
          *ngIf="activeTab === 'solutions'"
          id="solutions-panel"
          class="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="solutions-tab"
          tabindex="0"
        >

          <!-- Card 1 -->
          <div class="card m-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/dscmo.webp"
                  class="img-fluid"
                  alt="Cloud Migration and Optimization"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h4 class="heading-section-card">
                  Cloud Ops &amp; Mitigation
                </h4>

                <p class="para">
                  We guide your business through seamless migration of
                  applications, data, and workloads to cloud platforms like
                  AWS, Azure, and Google Cloud with minimal disruption.
                  Our tailored approach includes SaaS, PaaS, aiming to
                  improve scalability, flexibility, and operational efficiency.
                </p>

                <a
                  routerLink="/service/software-consulting-services/"
                  href="/service/software-consulting-services/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore cloud operations and mitigation"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

          <!-- Card 2 -->
          <div class="card m-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/dsda.webp"
                  class="img-fluid"
                  alt="DevOps Automation"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h4 class="heading-section-card">
                  DevOps Automation
                </h4>

                <p class="para">
                  Our team designs and develops native and cross-platform
                  mobile apps for iOS and Android, ensuring smooth user
                  experiences, high performance, and secure functionality
                  for businesses on the go.
                </p>

                <a
                  routerLink="/service/software-consulting-services/"
                  href="/service/software-consulting-services/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore DevOps automation"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

          <!-- Card 3 -->
          <div class="card m-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/dsvcis.webp"
                  class="img-fluid"
                  alt="Virtualization and Cloud Infrastructure Security"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h4 class="heading-section-card">
                  Virtualization &amp; Cloud Security
                </h4>

                <p class="para">
                  We enhance resource utilization and reduce infrastructure
                  costs through expert virtualization services. Combined
                  with advanced automation, we ensure your cloud environment
                  remains secure, efficient, and compliant using tools like
                  SonarQube and Snyk.
                </p>

                <a
                  routerLink="/service/software-consulting-services/"
                  href="/service/software-consulting-services/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore virtualization and cloud security"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

        </div>


        <!-- ==========================================================
             DIGITAL MARKETING
        =========================================================== -->
        <div
          *ngIf="activeTab === 'marketing'"
          id="marketing-panel"
          class="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="marketing-tab"
          tabindex="0"
        >

          <!-- Card 1 -->
          <div class="card m-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/dmseocm.webp"
                  class="img-fluid"
                  alt="SEO and Content Marketing"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h4 class="heading-section-card">
                  SEO &amp; Content Marketing
                </h4>

                <p class="para">
                  We optimize your digital presence with advanced SEO
                  techniques and high-quality content strategies. From
                  keyword research and technical SEO to blogs and landing
                  pages, we help your brand rank higher, attract the right
                  audience, and build authority online.
                </p>

                <a
                  routerLink="/service/digital-marketing/"
                  href="/service/digital-marketing/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore SEO and content marketing"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

          <!-- Card 2 -->
          <div class="card m-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/dmpm.webp"
                  class="img-fluid"
                  alt="Performance Marketing"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h4 class="heading-section-card">
                  Performance Marketing
                </h4>

                <p class="para">
                  Our team runs data-driven ad campaigns on Google, LinkedIn,
                  Facebook, and other platforms. By leveraging real-time
                  analytics and A/B testing, we maximize ROI, boost visibility,
                  and generate qualified leads tailored to your business goals.
                </p>

                <a
                  routerLink="/service/digital-marketing/"
                  href="/service/digital-marketing/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore performance marketing"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

          <!-- Card 3 -->
          <div class="card m-3">
            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-4 text-center text-md-start">
                <img
                  src="/assets/images/home/dmsmbe.webp"
                  class="img-fluid"
                  alt="Social Media and Brand Engagement"
                  loading="lazy"
                  width="500"
                  height="350"
                />
              </div>

              <div class="col-12 col-md-8 text-center text-md-start">
                <h4 class="heading-section-card">
                  Social Media &amp; Brand Impact
                </h4>

                <p class="para">
                  We craft engaging campaigns that connect with your audience
                  across platforms like LinkedIn, Twitter (X), Instagram, and
                  YouTube. Our strategies focus on building brand awareness,
                  fostering trust, and driving meaningful interactions that
                  translate into long-term customer relationships.
                </p>

                <a
                  routerLink="/service/digital-marketing/"
                  href="/service/digital-marketing/"
                  class="custom-button text-decoration-none"
                  aria-label="Explore social media and brand impact"
                >
                  Explore
                </a>
              </div>

            </div>
          </div>

        </div>

      </div>
      <!-- End tab-content -->

    </div>
    <!-- End col-12 -->

  </div>
  <!-- End row -->
</div>
<!-- End container -->


<!-- container -->

<div class="bg-light">
  <div class="container p-2">
    <div class="row products-section">
      <div class="text-center subHeading">Our Products</div>

      <!-- Transactional Emails -->
      <div class="col-12 col-md-4 p-3">
        <div class="card">
          <div class="card-header text-center">
            <img
              src="/assets/images/home/opte.webp"
              class="card-img-top"
              alt="Transactional Emails"
              loading="lazy"
            />
          </div>
          <div class="card-body text-center">
            <h4 class="card-title heading-section-card">
              Transactional Emails
            </h4>
            <p class="card-text para">
              Deliver secure and instant emails like OTPs, alerts, and
              confirmations.
            </p>
            <a
              routerLink="/product/transactional-emails/"
              href="/product/transactional-emails/"
              class="custom-button text-decoration-none"
              aria-label="Transactional Emails - Learn more about our Transactional Emails service"
            >
              Transactional Emails
            </a>
          </div>
        </div>
      </div>

      <!-- Email Validation -->
      <div class="col-12 col-md-4 p-3">
        <div class="card">
          <div class="card-header text-center">
            <img
              src="/assets/images/home/opev.webp"
              class="card-img-top"
              alt="Email Validation"
              loading="lazy"
              width="337"
              height="187"
            />
          </div>
          <div class="card-body text-center">
            <h4 class="card-title heading-section-card">
              Email Validation
            </h4>
            <p class="card-text para">
              Verify emails in real time to reduce bounces and improve delivery.
            </p>
            <a
              routerLink="/product/email-verifier/"
              href="/product/email-verifier/"
              class="custom-button text-decoration-none"
              aria-label="Email Validation - Learn more about our Email Verifier product"
            >
              Email Validation
            </a>
          </div>
        </div>
      </div>

      <!-- WhatsApp APIs -->
      <div class="col-12 col-md-4 p-3">
        <div class="card">
          <div class="card-header text-center">
            <img
              src="/assets/images/home/opwa.webp"
              class="card-img-top"
              alt="WhatsApp APIs"
              loading="lazy"
              width="337"
              height="168"
            />
          </div>
          <div class="card-body text-center">
            <h4 class="card-title heading-section-card">
              WhatsApp APIs
            </h4>
            <p class="card-text para">
              Engage customers on WhatsApp with alerts, support, and updates.
            </p>
            <a
              routerLink="/product/whatsapp-apis/"
              href="/product/whatsapp-apis/"
              class="custom-button text-decoration-none"
               aria-label="WhatsApp APIs - Learn more about our WhatsApp API solutions"
            >
              WhatsApp APIs
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container py-4">
  <div class="row text-center mb-4">
    <div class="fw-bold subHeading">Why Choose Us</div>
  </div>

  <div class="row g-4">
    <div class="col-12 col-md-4" *ngFor="let card of chooseUsCards">
      <div class="border-0 mb-5 card1 card">
        <div class="card-header border-0">
          <img
            [src]="card.img"
            [srcset]="card.imgSrcset"
            sizes="316px"
            width="316"
            height="211"
            class="card-img-top"
            [alt]="card.title"
            loading="lazy"
          />
        </div>
        <div class="card-body mt-2">
          <div class="card-title text-center heading-section-card1">{{ card.title }}</div>
          <p class="card-text para text-justify1">{{ card.text }}</p>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="container p-2">
  <div class="row support-section align-items-stretch">

    <!-- Heading -->
    <div class="col-12 text-center mb-4">
      <div class="subHeading">MALtech 24/7 Support</div>
      <p class="para">We are always here to support you.</p>
    </div>

    <!-- Left buttons -->
    <div class="col-12 col-md-6 d-flex support-col">
      <div class="support-inner">

        <div class="support-item">
          <a class="custom-tab-button w-100 h-100 text-decoration-none d-block" routerLink="/contact/" href="/contact/">
            24/7 Professional Support
          </a>
        </div>

        <div class="support-item">
          <a class="custom-tab-button w-100 h-100 text-decoration-none d-block" routerLink="/contact/" href="/contact/">
            99.5% Server Uptime
          </a>
        </div>

        <div class="support-item">
          <a class="custom-tab-button w-100 h-100 text-decoration-none d-block" routerLink="/contact/" href="/contact/">
            100% Client Satisfaction
          </a>
        </div>

        <div class="support-item mb-3">
          <a class="custom-tab-button w-100 h-100 text-decoration-none d-block" routerLink="/contact/" href="/contact/">
            99.9% Network Uptime
          </a>
        </div>

      </div>
    </div>
<!-- Right support options -->
<div class="col-12 col-md-6 d-flex support-col mt-3">
  <div class="support-inner">

    <!-- WhatsApp -->
    <div class="support-item">
      <a
        href="https://wa.me/917305809591"
        target="_blank"
        rel="noopener noreferrer"
        class="border cursor1 p-3 d-flex align-items-center h-100 text-decoration-none text-dark"
      >
        <i class="bi bi-whatsapp fs-3 me-3 text-info"></i>
        <p class="para mb-0">Connect with us directly on WhatsApp</p>
      </a>
    </div>

    <!-- Email -->
    <div class="support-item">
      <a
        href="https://mail.google.com/mail/?view=cm&fs=1&to=support@maltech.co"
        target="_blank"
        rel="noopener noreferrer"
        class="border cursor1 p-3 d-flex align-items-center h-100 text-decoration-none text-dark"
      >
        <i class="bi bi-envelope fs-3 me-3 text-info"></i>
        <p class="para mb-0">Connect with us directly on Email</p>
      </a>
    </div>

    <!-- Chat -->
    <div class="support-item">
      <a
        routerLink="/contact/"
        href="/contact/"
        class="border cursor1 p-3 d-flex align-items-center h-100 text-decoration-none text-dark"
      >
        <i class="bi bi-chat-dots fs-3 me-3 text-info"></i>
        <p class="para mb-0">Chat with us instantly via chat</p>
      </a>
    </div>

    <!-- Phone -->
    <div class="support-item">
      <a
        href="tel:+917305809591"
        class="border cursor1 p-3 d-flex align-items-center h-100 text-decoration-none text-dark"
      >
        <i class="bi bi-telephone fs-4 me-3 text-info"></i>
        <p class="para mb-0">Speak to our experts for quick help</p>
      </a>
    </div>

  </div>
</div>

  </div>
</div>


<!-- <div class="container p-2">
  <div class="text-center subHeading mb-3">Our Trusted Partners</div>

<div class="partner-marquee">
  <div class="partner-track">

    <img src="/assets/images/partners/otpsg-86.webp" srcset="/assets/images/partners/otpsg-86.webp 86w, /assets/images/partners/otpsg-172.webp 172w" sizes="86px" width="86" height="45" alt="SendGrid" />
    <img src="/assets/images/partners/otpeb-165.webp" srcset="/assets/images/partners/otpeb-165.webp 165w, /assets/images/partners/otpeb-330.webp 330w" sizes="165px" width="165" height="45" alt="Exabytes" />
    <img src="/assets/images/partners/otp10.webp" alt="10000 Startups" />
    <img src="/assets/images/partners/otphub.webp" alt="T-Hub" />
    <img src="/assets/images/partners/otpgdg.webp" alt="GDG" />


    <img src="/assets/images/partners/otpsg-86.webp" srcset="/assets/images/partners/otpsg-86.webp 86w, /assets/images/partners/otpsg-172.webp 172w" sizes="86px" width="86" height="45" alt="image1" />
    <img src="/assets/images/partners/otpeb-165.webp" srcset="/assets/images/partners/otpeb-165.webp 165w, /assets/images/partners/otpeb-330.webp 330w" sizes="165px" width="165" height="45" alt="image3" />
    <img src="/assets/images/partners/otp10.webp" alt="image4" />
    <img src="/assets/images/partners/otphub.webp" alt="image5" />
    <img src="/assets/images/partners/otpgdg.webp" alt="image6" />
  </div>
</div>
</div> -->



<!-- <div class="bg-light">
  <div class="container p-5">
  <div class="row clients-section">
    <div class="col-12 text-center">
      <h1>What Our Clients Say</h1>
      <div id="carouselExampleSlidesOnly" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active" data-bs-interval="2000">
            <div class="row">
              <div class="col-md-4 col-12 p-3 d-flex justify-content-center align-items-center">
                <img src="/assets/images/home/wocsg.png" class="d-block w-75 small" alt="...">
              </div>
              <div class="col-md-4 col-12 p-3 d-flex justify-content-center align-items-center">
                <img src="/assets/images/home/wocst.png" class="d-block w-75 big" alt="...">
              </div>
              <div class="col-md-4 col-12 p-3 d-flex justify-content-center align-items-center">
                <img src="/assets/images/home/wocss.png" class="d-block w-75 small" alt="...">
              </div>
            </div>
          </div>
          <div class="carousel-item" data-bs-interval="2000">
            <div class="row">
              <div class="col-md-4 col-12 p-3 d-flex justify-content-center align-items-center">
                <img src="/assets/images/home/wocst.png" class="d-block w-75 small" alt="...">
              </div>
              <div class="col-md-4 col-12 p-3 d-flex justify-content-center align-items-center">
                <img src="/assets/images/home/wocss.png" class="d-block w-75 big" alt="...">
              </div>
              <div class="col-md-4 col-12 p-3 d-flex justify-content-center align-items-center">
                <img src="/assets/images/home/wocsg.png" class="d-block w-75 small" alt="...">
              </div>
            </div>
          </div>
          <div class="carousel-item" data-bs-interval="2000">
            <div class="row">
              <div class="col-md-4 col-12 p-3 d-flex justify-content-center align-items-center">
                <img src="/assets/images/home/wocss.png" class="d-block  w-75 small" alt="...">
              </div>
              <div class="col-md-4 col-12 p-3 d-flex justify-content-center align-items-center">
                <img src="/assets/images/home/wocsg.png" class="d-block w-75 big" alt="...">
              </div>
              <div class="col-md-4 col-12 p-3 d-flex justify-content-center align-items-center">
                <img src="/assets/images/home/wocst.png" class="d-block w-75 small" alt="...">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  </div> -->

<div class="container py-5">
  <div class="row justify-content-center text-center">
    <div class="col-lg-8 col-md-10 col-12">
      <div class="mb-4 subHeading">Ready to Transform Your Business with MALtech?</div>
      <p class="mb-4">
        Trust our innovative solutions to accelerate your digital transformation
        journey. With future-ready technologies, we help businesses adapt,
        scale, and thrive in a competitive digital era.
      </p>
      <a
        class="btn custom-button btn-lg"
        routerLink="/contact/"
        href="/contact/"
        aria-label="Contact us"
      >
        Contact Us
      </a>
    </div>
  </div>
</div>